/**
 * One sentence for an RTK Query error, with the HTTP status when there is one.
 * Moved out of RunAnalysisButton so the SEO admin tabs share it
 * (Asana 1219288016488651).
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object') return fallback;
  const e = err as { status?: number | string; data?: unknown; error?: string };

  if (e.status === 'FETCH_ERROR' || e.status === 'TIMEOUT_ERROR') {
    return `${fallback} (${e.status}${e.error ? `: ${e.error}` : ''})`;
  }

  const { data } = e;
  if (data && typeof data === 'object') {
    const msg = (data as { message?: string }).message;
    if (msg) return `${msg}${e.status ? ` (HTTP ${e.status})` : ''}`;
  }
  if (typeof data === 'string' && data.length > 0) {
    try {
      const parsed = JSON.parse(data);
      if (parsed && typeof parsed === 'object' && typeof parsed.message === 'string') {
        return `${parsed.message}${e.status ? ` (HTTP ${e.status})` : ''}`;
      }
    } catch {
      // Not JSON — fall through to raw text snippet
    }
    const snippet = data.length > 200 ? `${data.slice(0, 200)}...` : data;
    return `${fallback}${e.status ? ` (HTTP ${e.status})` : ''}: ${snippet}`;
  }
  return `${fallback}${e.status ? ` (HTTP ${e.status})` : ''}`;
}

export default extractErrorMessage;
